<div class="sidenav-header"><b>Messages</b></div>
<mat-nav-list>
    <a mat-list-item routerLink="/postcards/create" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon matListItemIcon>add</mat-icon>
        Create
    </a>
    <a mat-list-item routerLink="/messages/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
        <mat-icon matListItemIcon>send</mat-icon>
        Postcards
    </a>
    <a mat-list-item routerLink="/campaigns/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
        <mat-icon matListItemIcon>campaign</mat-icon>
        Campaigns
    </a>
</mat-nav-list>
<div class="sidenav-header"><b>{{siteName}}</b></div>
<mat-nav-list>
    <a mat-list-item routerLink="/contact/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon matListItemIcon>comment</mat-icon>
        Feedback
    </a>
    <a mat-list-item routerLink="/faq/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon matListItemIcon>help</mat-icon>
        FAQ
    </a>
    <a mat-list-item routerLink="/tos/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <mat-icon matListItemIcon>policy</mat-icon>
        Terms of Service
    </a>
    <a mat-list-item routerLink="/" target="_blank">
        <mat-icon matListItemIcon>info</mat-icon>
        About
    </a>
</mat-nav-list>
@if( userService.currentUser) {
    <div class="sidenav-header"><b>Account</b></div>
    <mat-nav-list>
        <a mat-list-item routerLink="/user/orders/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <mat-icon matListItemIcon>receipt</mat-icon>
            Orders
        </a>
        <a mat-list-item routerLink="/user/settings/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <mat-icon matListItemIcon>settings</mat-icon>
            Settings
        </a>
        <a mat-list-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                Logout
        </a>
    </mat-nav-list>
}
<div id="company-id">
    &copy; TechnoUtopians Inc.<br /> &nbsp; &nbsp; All rights reserved.
</div>